import { ParcelDto } from '@shared/types/parcel';
import { WeightDto } from '@shared/types/weight';

export interface WeightCheckBagDto {
  id: number;
  number: string | null;
  userName: string | null;
  parcelsCount: number;
  actualWeight: WeightDto;
  closedAt: Date | null;
  createdAt: Date;
  bagCode: string;
  regionZone: string | null;
}

// Номера фиксированы на бэкенде (SortingCenter.Shared.Enum.CheckParcelWeightStatus)
export enum CheckParcelWeightStatus {
  WeightConfirmed = 0,
  WeightChanged = 1,
  NotFound = 2,
  NotAccepted = 3,
  Canceled = 4,
  NotInBag = 5,
  BagNotFound = 6,
  ServiceRestriction = 7,
}

export interface CheckParcelWeightResponse {
  status: CheckParcelWeightStatus;
  /** Вес с весов на приёмке, г */
  previousWeightGrams: number | null;
  /** Вес на проверке, г */
  newWeightGrams: number;
}

export type WeightCheckRowStatus = 'notChecked' | 'confirmed' | 'changed' | 'error';

export interface WeightCheckParcelRow extends Pick<ParcelDto, 'trackNumber' | 'factWeight'> {
  id: string;
  status: WeightCheckRowStatus;
  checkedWeight: number | null;
}

export const RESULT_MESSAGE_KEYS: Record<CheckParcelWeightStatus, string> = {
  [CheckParcelWeightStatus.WeightConfirmed]: 'weightCheck.result.confirmed',
  [CheckParcelWeightStatus.WeightChanged]: 'weightCheck.result.changed',
  [CheckParcelWeightStatus.NotFound]: 'weightCheck.result.notFound',
  [CheckParcelWeightStatus.NotAccepted]: 'weightCheck.result.notAccepted',
  [CheckParcelWeightStatus.Canceled]: 'weightCheck.result.canceled',
  [CheckParcelWeightStatus.NotInBag]: 'weightCheck.result.notInBag',
  [CheckParcelWeightStatus.BagNotFound]: 'weightCheck.result.bagNotFound',
  [CheckParcelWeightStatus.ServiceRestriction]: 'weightCheck.result.serviceRestriction',
};
